(function () {
  if (window.__alvaLocalizationHydrate) return;
  window.__alvaLocalizationHydrate = true;

  var request = null;

  function load() {
    if (!request) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      request = fetch(root + '?section_id=alva-country-options', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Country options ' + response.status);
          return response.text();
        })
        .catch(function (error) {
          request = null;
          throw error;
        });
    }
    return request;
  }

  function hydrate(toggle) {
    var wrapper = toggle.closest('.relative');
    var listbox = wrapper && wrapper.querySelector('[data-alva-country-list]');
    var template = listbox && listbox.querySelector('template[data-alva-country-options]');
    if (!template) return Promise.resolve(false);
    if (template.__alvaPending) return template.__alvaPending;

    var showFlags = template.getAttribute('data-flags') === '1';
    template.__alvaPending = load().then(function (html) {
      if (!template.isConnected) return false;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var options = doc.querySelectorAll('button[name="country_code"]');
      if (!options.length) throw new Error('Country options empty');
      var fragment = document.createDocumentFragment();
      options.forEach(function (option) {
        if (!showFlags) {
          option.querySelectorAll('.country-flag').forEach(function (flag) { flag.remove(); });
        }
        fragment.appendChild(document.importNode(option, true));
      });
      listbox.appendChild(fragment);
      template.remove();

      // If the popover opened before the list arrived, move focus to the
      // current country the way the theme's initial-focus would have.
      if (toggle.getAttribute('aria-expanded') === 'true') {
        var selected = listbox.querySelector('[aria-selected="true"]');
        if (selected) selected.focus({ preventScroll: true });
      }
      return true;
    }).catch(function () {
      template.__alvaPending = null;
      return false;
    });
    return template.__alvaPending;
  }

  function getToggle(event) {
    return event.target.closest && event.target.closest('.localization-toggle[aria-controls]');
  }

  function onIntent(event) {
    var toggle = getToggle(event);
    if (toggle) hydrate(toggle);
  }

  ['pointerover', 'focusin', 'touchstart', 'click'].forEach(function (name) {
    document.addEventListener(name, onIntent, { capture: true, passive: true });
  });

  // Touch devices have no hover: warm the list while the selector scrolls
  // toward view, at idle, so the first tap opens a full list.
  // Oct 8 2026: no longer checks toggle.offsetParent before observing. That read
  // forced a synchronous layout at DOMContentLoaded on every page (flagged by
  // Lighthouse as a forced reflow). Hidden toggles (the header copy is display:none
  // at every width) simply never report as intersecting, so the result is the same.
  function observe() {
    if (!('IntersectionObserver' in window)) return;
    var toggles = document.querySelectorAll('.localization-toggle[aria-controls]');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        warm(entry.target);
      });
    }, { rootMargin: '400px 0px' });
    toggles.forEach(function (toggle) { io.observe(toggle); });
  }
  function warm(toggle) {
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
    idle(function () { hydrate(toggle); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
  else observe();
})();
